import { Component, Input } from '@angular/core';
import { Subject, Subscription } from 'rxjs';

@Component({
  selector: 'app-circle-progress',
  templateUrl: './circle-progress.component.html',
  styleUrl: './circle-progress.component.scss',
})
export class CircleProgressComponent {
  @Input() onStart: Subject<void>;
  @Input() progressTime: number = 10000; // default to 10 seconds

  progress = 0;

  interval: any;
  subscription: Subscription;

  constructor() {}

  ngOnInit() {
    this.startAnimation(); // Start immediately on init
    if (this.onStart) {
      this.subscription = this.onStart.subscribe(() => this.startAnimation());
    }
  }

  startAnimation() {
    clearInterval(this.interval);
    this.interval = setInterval(() => {
      this.progress = this.progressTime
        ? (this.progress += 100 / (this.progressTime / 100))
        : 0;
      if (this.progress > 100) {
        clearInterval(this.interval);
        this.progress = 0;
      }
    }, 100);
  }

  ngOnDestroy() {
    this.subscription?.unsubscribe();
  }

  get secondsLeft(): number {
    return parseInt(
      Math.ceil(((100 - this.progress) * this.progressTime) / 1000) / 100 + ''
    );
  }
}
